'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flex');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/flex.js
// module id = 4487
// module chunks = 168707334958949